import { render, staticRenderFns } from "./UserCoinsOverlay.vue?vue&type=template&id=52c4fdbc&scoped=true"
import script from "./UserCoinsOverlay.vue?vue&type=script&lang=js"
export * from "./UserCoinsOverlay.vue?vue&type=script&lang=js"
import style0 from "./UserCoinsOverlay.vue?vue&type=style&index=0&id=52c4fdbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4fdbc",
  null
  
)

export default component.exports